// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledQuickGuide = styled('div')(
  () => css`
    .quick-guide {
      padding: 12px;
      background-color: #e1e8ff;
      margin: 0 0 16px;

      &-title {
        margin-bottom: 8px;
        display: flex;
        font-weight: 700;
        font-size: 0.75rem;
        line-height: 1.5rem;
        color: #0c395a;

        .icon {
          margin-left: 5px;
        }
      }

      &-text {
        font-weight: 400;
        font-size: 0.87rem;
        line-height: 1.25rem;
        color: #3c607a;
      }

      video {
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
      }

      .ui-stepper {
        box-sizing: border-box;
        width: 100%;
        background-color: #e1e8ff;

        .MuiMobileStepper-dotActive {
          background-color: #4c6fff;
        }
      }

      .MuiButton-root {
        color: #4c6fff;
        font-weight: 700;
        font-size: 0.75rem;

        .MuiButton-endIcon {
          margin-left: 0;
        }
      }

      &.singular-stepper {
        .ui-stepper {
          display: none;
        }
      }
    }
  `
);
